var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({ref:"image",class:_vm.classes,attrs:{"id":_vm.id ? `c${_vm.id}` : undefined,"src":_vm.link.url},on:{"error":_vm.imageLoadingError}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }